<template>
  <div
    class="cc-app-beta-banner"
    v-if="visible"
  >
    <div class="cc-app-beta-banner__inner">
      <v-icon
        class="cc-app-beta-banner__icon"
        :icon="Icons.ROCKET"
      />
      <span class="cc-app-beta-banner__text">
        {{ t('appBeta.text') }}
      </span>
      <v-btn
        class="cc-app-beta-banner__cta"
        variant="flat"
        size="small"
        :href="mailtoHref"
      >
        {{ t('appBeta.cta') }}
      </v-btn>
      <v-btn
        class="cc-app-beta-banner__close"
        icon
        variant="text"
        size="small"
        :aria-label="t('appBeta.close')"
        @click="dismiss"
      >
        <v-icon :icon="Icons.CLOSE" />
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
//================= [CSS] =====================================

//================= [JS] ======================================
import {Icons} from '@simpleforyou/client-core';
//================= [VUE COMPONENTS] ==========================
import {onMounted, onUnmounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

// Feature flag — only enable once BOTH iOS and Android are available so we
// don't recruit testers for a platform that doesn't exist yet (see web#65).
const BANNER_ENABLED = false;
const STORAGE_KEY = 'cc-app-beta-banner-dismissed';
// Toggled on <html> so the layout (fixed app bar + main content) can shift
// down by the banner height — see assets/scss/modern.scss.
const ROOT_CLASS = 'cc-app-beta-active';

const mailtoHref = `mailto:info@simpleforyou.de?subject=${encodeURIComponent(t('appBeta.mailSubject'))}`;
const visible = ref(BANNER_ENABLED && localStorage.getItem(STORAGE_KEY) !== '1');

const syncRootClass = (active: boolean) => {
  document.documentElement.classList.toggle(ROOT_CLASS, active);
};

const dismiss = () => {
  localStorage.setItem(STORAGE_KEY, '1');
  visible.value = false;
};

watch(visible, (value) => syncRootClass(value));
onMounted(() => syncRootClass(visible.value));
onUnmounted(() => syncRootClass(false));
</script>

<style scoped lang="scss">
.cc-app-beta-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 52px;
  z-index: 1010;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
  color: #fff;
}

.cc-app-beta-banner__inner {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

.cc-app-beta-banner__icon {
  color: #fff;
  opacity: 0.95;
}

.cc-app-beta-banner__text {
  flex: 1 1 auto;
  font-weight: 600;
  font-size: 0.95rem;
}

.cc-app-beta-banner__cta {
  background: #fff !important;
  color: var(--primary) !important;
  font-weight: 600;
}

.cc-app-beta-banner__close {
  color: #fff !important;
}
</style>
